__turbopack_context__.v({
  "logo": "logo-module-scss-module__RMYTqa__logo",
});
